export default {
  // enable/disable camera
  toggleCamera(state) {
    this.enableVideo = state;
    if (this.localVideoTrack) {
      const isEnabled = state && !this.constraints.screen ? true : false;
      this.localVideoTrack.getMediaStreamTrack().enabled = isEnabled;
    }
  }
}

